import {Field} from 'formik';
import {FormikTextInput} from 'shipwell-ui';

const SpecialInstructionsField = ({...props}) => (
  <Field label="Special Instructions" name="info_message" component={FormikTextInput} {...props} />
);

export default SpecialInstructionsField;
